// extracted by mini-css-extract-plugin
module.exports = {"primary":"#000000","secondary":"#ffcc00"};